import React from "react";
import {connect} from "react-redux";
import ChatDialog from '../dialog/ChatDialog';
import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client';
import Message from '../dialog/message';
import {RECEIVED_MESSAGE} from '../../reducers/testreceive';

class Dummy extends React.Component {
    sendMessage = (msg) => {
        const message = new Message(msg, true);
        if (this.state.stomp) {
            this.state.stomp.send('/app/bot', message.getText());
            this.props.dispatch({
                type: RECEIVED_MESSAGE,
                message: message
            });
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            stomp: undefined
        };
    }

    componentWillMount() {
        let sessionId = "testClient1";
        const socket = new SockJS('http://localhost:8080/api/ws', [], {
            sessionId: () => {
                return sessionId
            }
        });
        //https://stackoverflow.com/questions/28009764/how-to-get-session-id-on-the-client-side-websocket/35651029#35651029
        //const socket = new SockJS('https://ip20-bot.i-pioneers.de/api/ws');
        const stomp = webstomp.over(socket);
        const self = this;
        stomp.connect({}, () => {
            var sessionId = /\/([^/]+)\/websocket/.exec(socket._transport.url)[1];
            console.log("connected, session id: " + sessionId);
            stomp.subscribe('/user/queue/bot', (message) => {
                self.props.dispatch({
                    type: RECEIVED_MESSAGE,
                    message: message instanceof Message ? message : new Message(message.body, false)
                });
            });
            self.setState({stomp});
        });


    }

    componentWillUnmount() {
        if (this.state.stomp) {
            this.state.stomp.disconnect();
        }
    }

    render() {

        return (
            <div style={this.props.style}>
                <ChatDialog send={this.sendMessage} messages={this.props.messages}/>
            </div>
        )
    }
}


const mapState = ({testReceive}) => ({messages: testReceive.messages});
export default connect(mapState)(Dummy)



// WEBPACK FOOTER //
// ./src/components/testClient/Dummy.js